import BaseAuth from '../auth/BaseAuth';

class APIGateway extends BaseAuth {
  request = async (method, action, body) => {
    try {
      const url = `${this.baseUrl}/${action}`;
      let token = await this.getAccessToken();
      if (token) {
        token = { Authorization: `Bearer ${token}` };
      }
      const options = {
        method,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          ...token,
        },
        body: JSON.stringify(body),
      };
      if (this.isDev) {
        // eslint-disable-next-line no-console
        console.log('API Gateway REQUEST:', { url, options });
      }
      const response = await fetch(url, options);
      let data = {};
      if (response.status !== 201) {
        const json = await response.json();
        data = response.ok
          ? json
          : {
            err: !response.ok,
            ...json,
          };
      } else {
        data = response.ok
          ? { status: 201 }
          : {
            err: !response.ok,
          };
      }
      if (response?.status === 401) {
        const refTk = await this.getRefreshToken();
        if (refTk) {
          window.location = `/client/auth?from=${window.location.pathname}`;
        } else {
          window.location = '/';
        }
      }
      if (response?.status === 403) {
        window.location = `/client/auth?from=${window.location.pathname}`;
      }
      if (this.isDev) {
        // eslint-disable-next-line no-console
        // console.log('API Gateway Request RESPONSE:', data);
      }
      return data;
    } catch (e) {
      if (this.isDev) {
        // eslint-disable-next-line no-console
        console.log('API Gateway Request API ERROR:', e);
      }
      return {
        err: true,
        message:
          'There was an error processing your request, please try again.',
      };
    }
  };
  getActivityGroupByEventId = async eventId => {
    const resp = this.request(
      'GET',
      `activity-hub/v1/activity/group/event/${eventId}`,
    );
    return resp;
  };

  submitActivityComment = async paylod => {
    const resp = this.request(
      'POST',
      'activity-hub/v1/activity/recordActivityResponse?source=WEB',
      paylod,
    );
    return resp;
  };

  getEventStatus = async eventId => {
    const resp = this.request(
      'GET',
      `community-service/v1/getUserStatusAction?eventId=${eventId}`,
    );
    return resp;
  };

  enrollToLoyaltyProgram = async userId => {
    const postBody = {
      enrollmentName: 'Loyalty',
      personId: userId,
    };
    const resp = this.request(
      'POST',
      'community-service/enroll/user',
      postBody,
    );
    return resp;
  };

  getAvailableEventRewards = async eventId => {
    const resp = this.request(
      'GET',
      `event/events/getAllProductsByEvent/${eventId}`,
    );
    return resp;
  };
  unsubscribeNotifications = async data => {
    return this.request(
      'POST',
      'notification/v1/notifications/suppressionList/add',
      data,
    );
  };

  getRewardCatalogue = async (itemType, pageNo, pageSize) => {
    const resp = this.request(
      'GET',
      `invoke/reward-service/v1/rewardCatalog/rewardedCatalogItems/list?itemType=${itemType}&pageNo=${pageNo}&pageSize=${pageSize}`,
    );
    return resp;
  };
  getUserWallet = async (pagSize, pageNo = 1) => {
    const resp = this.request(
      'GET',
      `invoke/user-wallet-manager/user/wallet/transactions?pageNo=${pageNo}&pageSize=${pagSize}`,
    );
    return resp;
  };
  redeemCards = async data => {
    return this.request(
      'POST',
      'invoke/reward-service/v1/tremendousProduct/claim',
      data,
    );
  };

  subscribeNotifications = async email => {
    return this.request(
      'DELETE',
      `notification/v1/notifications/suppressionList/${email}`,
    );
  };
  getSubscriptionStatus = async email => {
    return this.request(
      'GET',
      `notification/v1/notifications/suppressionList/${email}/isExists`,
    );
  };
  debitWallet = async data => {
    return this.request('POST', 'invoke/user-wallet-manager/debit', data);
  };

  getEventDetailsBySlug = async slug => {
    return this.request('GET', `event/events/getEventDetailBySlug/${slug}`);
  };

  getRewardDetailsByEventId = async id => {
    return this.request('GET', `reward-service/v1/reward/list/${id}`);
  };

  getNumberOfPacksAndParticipants = async eventId => {
    return this.request(
      'GET',
      `event/events/packAndApplicationCountByEventId/${eventId}`,
    );
  };

  generateFileUploadPresignedUrl = async data => {
    return this.request('POST', 'common-service/v1/preSignedUrl', data);
  };

  uploadUGC = async (url, file) => {
    return fetch(url, { method: 'PUT', body: file });
  };

  getGameOptionBySlug = async (gameId, slug) => {
    return this.request(
      'GET',
      `invoke/gamification/v1/game/${gameId}/option/${slug}`,
    );
  };

  postJoinConversation = async data => {
    return this.request(
      'POST',
      'activity-hub/v1/activity/recordActivityResponse',
      data,
    );
  };

  joinConversation = async data => {
    return this.request(
      'POST',
      'activityugcreview/v1/discussions',
      data,
    );
  };

  getPreSignedURLApi = async (data) => {
    return this.request(
      'POST',
      'activityugcreview/client_api/getPreSignedURL',
      data,
    );
  };
  getFeedComments = async data => {
    return this.request(
      'POST',
      'event/events-feed/feed/comments',
      data,
    );
  };
}

export default new APIGateway({
  baseUrl: process.env.MS_API_GATEWAY_URL,
  isDev: process.env.NODE_ENV === 'development',
});
